<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">组织架构-{{ title }}库房</span>
      </div>

      <el-form label-position="top" ref="form" :model="form" :rules="rules">
        <div class="edit-card">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">库房基础信息</span>
          </div>
          <div class="card-content" style="width: 320px">
            <el-form-item label="库房编码" prop="no">
              <el-input disabled v-model="form.no" placeholder="系统自动生成"></el-input>
            </el-form-item>
            <el-form-item label="库房名称" prop="name">
              <el-input v-model="form.name" placeholder="请填写库房名称"></el-input>
            </el-form-item>
            <el-form-item label="库房类型" prop="sourceType">
              <el-select v-model="form.sourceType" placeholder="请选择库房类型" style="width: 100%" clearable multiple >
                <template >
                  <el-option v-for="item in WarehouseTypeOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="库房级别" prop="category">
              <el-select v-model="form.category" placeholder="请选择级别" style="width: 100%">
                <template v-for="(item, index) in LevelOptions">
                  <el-option v-if="index < 2" :key="item.id" :label="item.name + '库房'" :value="item.id"></el-option>
                </template>
              </el-select>
            </el-form-item>
            <el-form-item label="位置" prop="address">

              <div class="addressBox">
                <el-tag :key="tag" v-for="(tag, index) in dynamicTags" closable @dblclick.native="tagDbClickEvt(index)"
                  :disable-transitions="false" @close="handleClose(tag)">
                  {{ tag }}
                 
                </el-tag>
                <el-input ref="tagInput" v-if="tagIndex!=null" v-model="tagInput" @blur="tegInputEvt(tagIndex)"
                @keyup.enter.native="tegInputEvt(tagIndex)" />
                <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput"
                  placeholder='请输入标签' size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
                </el-input>
                <div v-else class="addAddress" size="small" @click="showInput">+新建位置</div>

              </div>
              <!-- <el-input v-model="form.address" placeholder="请填写位置"></el-input> -->
            </el-form-item>
            <el-form-item label="管理员" prop="managerId">
              <el-select v-model="form.managerName" placeholder="请选择管理员" filterable :filter-method="getUsers"
                style="width: 100%" @change="managerChange">
                <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name"
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="联系方式" prop="phone">
              <el-input v-model="form.phone" placeholder="请填写联系方式"></el-input>
            </el-form-item>
            <el-form-item label="库房协管员" prop="warnIdArr">
              <el-select v-model="form.warnIdArr" placeholder="请选择库房协管员" filterable multiple :filter-method="getUsers"
                style="width: 100%" @change="warnChange">
                <el-option v-for="item in STATIC_Users" :key="item.id" :label="item.no + ' ' + item.name" 
                  :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </div>

        <div class="edit-card" style="margin-top: 10px">
          <div style="width: 88%; display: flex">
            <div class="start-label" />
            <span class="text">库房详细信息</span>
          </div>

          <div class="card-content">
            <el-form-item label="关联科室" prop="deptIds">
              <div class="select_multiple_value" v-if="system_setting.IsUseWard" v-preventReClick
                @click="showDeptTreeDialog">
                <template>
                  <div  v-for="item in deptTreeData" :key="item.idGroup" class="value">
                    <span>{{ item.deptName + " " + (item.wardName ? item.wardName : '') + " " }}
                      <i class="el-icon-close" style="cursor: pointer" v-preventReClick
                        @click="removeItem1(item, $event)" />
                    </span>
                  </div>
                </template>
                <div style="clear: both"></div>
              </div>

              <div class="select_multiple_value" v-else v-preventReClick @click="showDeptCheckDialog">
                <template >
                  <div v-for="item in deptChecked" :key="item.id" class="value">
                    <span>{{ item.no + " " + item.name + " " }}
                      <i class="el-icon-close" style="cursor: pointer" v-preventReClick
                        @click="removeItem(item, $event)" />
                    </span>
                  </div>
                </template>
                <div style="clear: both"></div>
              </div>
            </el-form-item>

            <template>
              <el-form-item  v-for="(location, index) in form.details" :key="location.id">
                <label slot="label">
                  <div>
                    <span>{{
                      "新增货位(" + Arabia_To_SimplifiedChinese(index + 1) + ")"
                      }}</span>
                    <span style="margin-left: 50px" class="color-blue pointer" type="text" v-preventReClick
                      @click="removeLocation(location)">删除</span>
                  </div>
                </label>
                <el-input v-model="location.name" style="width: 320px" @focus="editLocation(location)"></el-input>
              </el-form-item>
            </template>
            <div style="cursor: pointer" v-preventReClick @click="addLocation">
              <img src="@/assets/icons/plus-blue.png" alt="" class="addbtn" />
              <span style="font-size: 13px; color: #286ab4; margin-left: 5px">新增货位</span>
            </div>
            <el-row>
              <el-col :span="4">
                <el-form-item label="是否自动生成科室入库">
                  <el-switch v-model="form.isAutoCreateDeptInStock" active-color="#286AB4" inactive-color="#D4D4D4"
                    :active-value="1" :inactive-value="0" :disabled="Boolean(form.billingDecoupled)">
                  </el-switch>
                  <span v-if="form.isAutoCreateDeptInStock">已启用</span>
                  <span v-else>未启用</span>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item v-if="form.category == 2" label="不计费耗材即入即出">
                  <el-switch v-model="form.notChargeInOutStock" active-color="#286AB4" inactive-color="#D4D4D4"
                    :active-value="1" :inactive-value="0" >
                  </el-switch>
                  <span v-if="form.notChargeInOutStock">已启用</span>
                  <span v-else>未启用</span>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item v-if="form.category == 2" label="普通计费耗材出柜自动领出">
                  <el-switch v-model="form.cabinetAutoTakeOut" active-color="#286AB4" inactive-color="#D4D4D4"
                    :active-value="1" :inactive-value="0">
                  </el-switch>
                  <span v-if="form.cabinetAutoTakeOut">已启用</span>
                  <span v-else>未启用</span>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item v-if="(form.category == 2||form.category == 1)&&system_setting.IsUsePDA" label="货位精细化管理">
                  <el-switch v-model="form.fineCargoLocation" active-color="#286AB4" inactive-color="#D4D4D4"
                    :active-value="1" :inactive-value="0">
                  </el-switch>
                  <span v-if="form.fineCargoLocation">已启用</span>
                  <span v-else>未启用</span>
                </el-form-item>
              </el-col>
               <el-col :span="4">
                <el-form-item v-if="form.category == 1&&system_setting.IsUsePDA" label="采购入库上架方式">
                  <el-select v-model="form.listingMethod" placeholder="请选择库房类型" style="width: 100%" clearable  >
                    <el-option label="以验收单为源上架即入库" :value="0"></el-option>
                    <el-option label="以入库单为源仅上架" :value="1"></el-option>
                  </el-select>
                </el-form-item>
               </el-col>
            </el-row>
          </div>
        </div>
        <el-row>
          <el-col :span="6">
            <el-form-item label="启用状态">
              <el-switch v-model="form.state" active-color="#286AB4" inactive-color="#D4D4D4" :active-value="1"
                :inactive-value="0">
              </el-switch>
              <span v-if="form.state">已启用</span>
              <span v-else>未启用</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="二级库启用状态">
              <el-switch v-model="form.isOpenSecondWarehouse" active-color="#286AB4" inactive-color="#D4D4D4"
                :active-value="1" :inactive-value="0">
              </el-switch>
              <span v-if="form.isOpenSecondWarehouse">已启用</span>
              <span v-else>未启用</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="三级库启用状态">
              <el-switch v-model="form.isOpenThreeWarehouse" active-color="#286AB4" inactive-color="#D4D4D4"
                :active-value="1" :inactive-value="0">
              </el-switch>
              <span v-if="form.isOpenThreeWarehouse">已启用</span>
              <span v-else>未启用</span>
            </el-form-item>
          </el-col>
             <el-col :span="6">
            <el-form-item label="计费与柜子解耦">
              <el-switch v-model="form.billingDecoupled" active-color="#286AB4" inactive-color="#D4D4D4"
                :active-value="1" :inactive-value="0" @change="billingDecoupledChange">
              </el-switch>
              <span v-if="form.billingDecoupled">已启用</span>
              <span v-else>未启用</span>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-dialog :title="title + '货位'" :visible.sync="openLocationDialog" :center="true" width="500px"
        :before-close="locationCancel" :close-on-click-modal="false">
        <el-form label-position="top" label-width="80px" ref="locationForm" :model="locationForm"
          :rules="locationRules">
          <el-row>
            <el-col :span="24">
              <el-form-item label="货位编码" prop="no">
                <el-input v-model="locationForm.no"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="货位名称" prop="name">
                <el-input v-model="locationForm.name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="环境分类" prop="environmentClassify">
              <el-select v-model="form.environmentClassify" placeholder="请选择环境分类" style="width: 100%" clearable multiple >
                <template>
                  <el-option  v-for="item in EnvironmentClassifyOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </template>
              </el-select>
            </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="remark">
                <el-input v-model="locationForm.remark"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" style="">
          <el-button class="btn default" v-preventReClick @click="locationCancel">取 消</el-button>
          <el-button class="btn primary" v-preventReClick @click="locationSubmit">确 定</el-button>
        </div>
      </el-dialog>
      <MyTableTree v-if="showDeptTreeDialogBox" :show="showDeptTreeDialogBox" :data="deptTreeList1"
        @getData="getDeptTreeDatas" :oldData="deptTreeData" @closeEvt="deptDeptTreeDialogClose"
        @filterMethod="GetDeptTreeData" />

      <my-tree :show="showDeptCheckBox" @close="deptCheckDialogClose" :showRight="false" @getData="getDeptDatas"
        :leftData="deptTreeList" :oldData="deptChecked" @filterMethod="getDeptTreeList"></my-tree>
    </div>
    <div slot="footer" class="footer-bottom">
      <el-button class="btn default" v-preventReClick @click="cancel">取 消</el-button>
      <el-button class="btn primary" type="primary" v-preventReClick @click="submit">确 定</el-button>
    </div>
  </div>
</template>

<script>
import GetDataMixin from "@/mixin/getData-mixin.js";
import {
  GetDeptTreeList,
  GetDeptAndWards,
  SaveWarehouse,
  IsExistBindDepts,
  GetWarehouseById,
} from "@/api";
import MyTree from "@/components/my-tree";
import MyTableTree from "@/components/my-table-tree";
import {
  Arabia_To_SimplifiedChinese
} from "@/utils/number.js";
import {
  LevelOptions,
  WarehouseTypeOptions,
  EnvironmentClassifyOptions
} from "@/enum";
// import SelectTable from "@/components/select-table";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
export default {
  name: "userEdit",
  mixins: [GetDataMixin, GetDataSpdMixin],
  components: {
    MyTree,
    MyTableTree,
    // SelectTable
  },
  data () {
    return {
      title: "",
      form: {},
      deptTreeList: [],
      deptTreeList1: [],
      deptChecked: [],
      deptTreeData: [],
      showDeptCheckBox: false,
      Arabia_To_SimplifiedChinese: Arabia_To_SimplifiedChinese,
      LevelOptions: LevelOptions,
      WarehouseTypeOptions:WarehouseTypeOptions,
      EnvironmentClassifyOptions:EnvironmentClassifyOptions,
      showDeptTreeDialogBox: false,
      locationForm: {},
      openLocationDialog: false,
      warnForm: {},
      openSettingDialog: false,
      //
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      tags: [],
      tagIndex: null,
      tagInput: '',
      //
      rules: {
        // no: [{ required: true, message: "请输入编码", trigger: "blur" }],
        name: [{
          required: true,
          message: "请输入名称",
          trigger: "blur",
        },],
        deptIds: [{
          required: true,
          message: "请选择库房所属科室",
          trigger: "blur",
        },],
        sourceType: [{
          required: true,
          message: "请选择库房类型",
          trigger: "blur",
        },],
        category: [{
          required: true,
          message: "请选择库房级别",
          trigger: "blur",
        },],
        managerId: [{
          required: true,
          message: "请选择管理员",
          trigger: "blur",
        },],
        phone: [{
          required: true,
          message: "联系电话不能为空",
          trigger: "blur",
        },
        {
          pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,
          message: "请输入正确的手机号码",
          trigger: "blur",
        },
        ],
      },
      locationRules: {
        no: [{
          required: true,
          message: "请输入货位编码",
          trigger: "blur",
        },],
        name: [{
          required: true,
          message: "请输入货位名称",
          trigger: "blur",
        },],
        // environmentClassify: [{
        //   required: true,
        //   message: "请输入环境类型",
        //   trigger: "blur",
        // },],
      },
      settingRules: {
        warnIds: [{
          required: true,
          message: "请选择库存提示对象",
          trigger: "blur",
        },],
        productName: [{
          required: true,
          message: "请选择供货产品",
          trigger: "blur",
        },],
        max: [{
          required: true,
          message: "请输入库存上限",
          trigger: "blur",
        },],
        min: [{
          required: true,
          message: "请输入库存下限",
          trigger: "blur",
        },],
      },
    };
  },
  props: {
    // title: {
    //   type: String,
    //   default () {
    //     return ''
    //   }
    // }
  },
  created () {
    
    var query = this.$route.query;
    if (query.id) {
      this.handleUpdate(query.id);
    } else {
      this.handleAdd();
    }
    this.GetDeptTreeData("");
    this.getDeptTreeList("");
    this.getWarehouses("");
    this.getUsers("");
    this.getProductList("");
  },
  methods: {
    managerChange (val) {
      this.form.managerId = val;
    },
    warnChange (val) {
      // this.form.warnId = val;
      this.form.Accepters = val.join(";");
    },
    // 新建
    handleAdd () {
      this.title = "新建";
      this.resetForm();
    },
    // 编辑
    handleUpdate (id) {
      GetWarehouseById({
        id,
      }).then((res) => {
        this.resetForm();
        this.form = res.returnData;
        this.dynamicTags = res.returnData.address?res.returnData.address.split(';'):[]
        if (this.system_setting.IsUseWard) {
          this.deptTreeData = this.form.deptAndWardInfos
          // this.form.deptIds = this.form.deptAndWardIds
        } else {
          this.deptChecked = this.form.deptInfos;
        }
        if (!this.form.warnDetails) {
          this.form.warnDetails = [];
        }
        if (!this.form.details) {
          this.form.details = [];
        }
        this.form.details.forEach((e, index) => {
          e.$index = index + 1;
        });
        this.form.warnDetails.forEach((e, index) => {
          e.$index = index + 1;
        });
        if (res.returnData.warnInfos) {
          this.$set(
            this.form,
            "warnIdArr",
            res.returnData.warnInfos.map((item) => item.id)
          );
          res.returnData.warnInfos.map((item) => {
            var user = this.STATIC_Users.filter((e) => e.id == item.id);
            if (!user || user.length == 0) {
              this.STATIC_Users.push(item);
            }
          });
        }

        // this.form.state = Boolean(this.form.state);
        this.title = "编辑";
      });
    },
    // 保存
    submit () {
      this.$refs["form"].validate((valid) => {
        if (!valid) {
          return false;
        }
        let deptIds = ''
        if (this.system_setting.IsUseWard) {
          deptIds = this.form.deptAndWardIds
        } else {
          deptIds = this.form.deptIds
        }
        // 查询科室是否被其他库房关联
        IsExistBindDepts({
          deptIds,
          warehouseId: this.form.id,
        }).then((res) => {
          // res.returnData = [{ deptName: "科室1", warehouseName: "库房1" }, { deptName: "科室2", warehouseName: "库房2" }]
          if (res.returnData && res.returnData.length > 0) {
            let msg = "";
            // const h = this.$createElement;
            // const newDatas = [];
            // newDatas.push(h("p", null, "您正在执行为科室更换绑定库房的操作:"));
            // h.text = "您正在执行为科室更换绑定库房的操作:"
            // newDatas.push(h());
            // let msg = ''
            res.returnData.forEach((item) => {
              if (msg) {
                msg += "<br/>";
              }
              msg += `[${item.deptName}] 已关联 [${item.warehouseName}]`;
              // newDatas.push(
              //   h("p", null, `${item.deptName}已关联${item.warehouseName}`)
              // );
            });
            msg += `<br/>确定将此科室重新绑定到当前库房，并取消与原库房的绑定关系`;
            // 存在关联提醒用户，需要用户确定是否更新
            // newDatas.push(h("p", null, `是否都更新至当前库房？`));
            // console.log(newDatas)
            // this.$my_confirm("提示", {
            //   title: "提示",
            //   message: h("div", null, newDatas),
            //   showCancelButton: true,
            //   type: "warning",
            // })
            this.$my_confirm("您正在执行为科室更换绑定库房的操作:<br/>" + msg, "提示", {
              type: "warning",
            })
              .then(() => {
            
                this.saveWarehouse(this.form);
              })
              .catch(() => { });

            return;
          } else {
            // 不存在关联直接更新
            this.saveWarehouse();
          }
        });
      });
    },
    saveWarehouse () {
      this.form.address = this.dynamicTags.join(';')
      SaveWarehouse(this.form).then((res) => {
        this.$my_message(`执行成功`, "success");
        sessionStorage.setItem("editMode", 0);
        this.$router.push({
          path: this.getMainPath(this.$route.path),
        });
      });
    },
    resetForm () {
      this.form = {
        name: "",
        state: 1,
        sourceType: [1],
        environmentClassify: [1],
        category: 1,
        details: [],
        warnDetails: [],
        deptIds: "",
        Accepters: "",
        warnIdArr: [],
        warnInfos: [],
        orgCode :sessionStorage.getItem('orgId'),
      };
    },
    // 取消编辑部门
    cancel () {
      // this.$my_confirm("确认要中断当前操作吗？", "提示", {
      //   type: "warning",
      // }).then(() => {
      //   this.$router.go(-1);
      // });
      this.$router.push({
        path: this.getMainPath(this.$route.path),
      });
    },
    showDeptCheckDialog () {
      this.showDeptCheckBox = true;
    },
    showDeptTreeDialog () {
      this.showDeptTreeDialogBox = true;
      this.GetDeptTreeData("");
    },
    deptCheckDialogClose () {
      this.showDeptCheckBox = false;
    },
    deptDeptTreeDialogClose () {
      this.showDeptTreeDialogBox = false;
    },
    getDeptDatas (datas) {
      this.deptChecked = datas;
      this.form.deptIds = this.deptChecked ?
        this.deptChecked.map((i) => i.id).join(";") :
        "";
      // this.form.deptId = this.deptChecked ? this.deptChecked[0].id : ''
      // this.form.deptNames = this.deptChecked ? this.deptChecked.map(i => i.no + ' ' + i.name) : []
    },
    getDeptTreeDatas (data) {
      this.showDeptTreeDialogBox = false
      this.deptTreeData = data;
      this.form.deptIds = this.deptTreeData ? Array.from(new Set(this.deptTreeData.map((i) => i.deptId))).join(";") : ''
      this.form.wardIds = this.deptTreeData ? Array.from(new Set(this.deptTreeData.map((i) => i.wardId))).join(";") : ''
      this.form.deptAndWardIds = this.deptTreeData ? Array.from(new Set(this.deptTreeData.map((i) => i.idGroup))).join(";") : ''
      console.log(this.form);
      // this.form.deptIds
    },
    showWarehouseCheckDialog () {
      this.showWarehouseCheckBox = true;
    },
    warehouseCheckDialogClose () {
      this.showWarehouseCheckBox = false;
    },
    getWarehouseDatas (datas) {
      this.warehouseChecked = datas;
      this.form.warehouseIds = this.warehouseChecked ?
        this.warehouseChecked.map((i) => i.id).join(";") :
        "";
    },
    getDeptTreeList (val) {
      let data  = {
        keyWord: val,
        pageIndex:1,
        pageSize:100,
      }
      GetDeptTreeList(data).then((res) => {
        this.deptTreeList = res.returnData;
      });
    },
    GetDeptTreeData (val) {
      GetDeptAndWards({
        keyWord: val
      }).then((res) => {
        this.deptTreeList1 = res.returnData;
      });
    },
    removeItem1 (item, e) {
      this.deptTreeData = this.deptTreeData.filter((i) => i.idGroup != item.idGroup);
      this.form.deptIds = this.deptTreeData ?
        this.deptTreeData.map((i) => i.deptId).join(";") :
        "";
      this.form.deptAndWardIds = this.deptTreeData ?
        this.deptTreeData.map((i) => i.idGroup).join(";") :
        "";

      e.stopPropagation();
    },
    removeItem (item, e) {
      this.deptChecked = this.deptChecked.filter((i) => i.id != item.id);
      this.form.deptIds = this.deptChecked ?
        this.deptChecked.map((i) => i.id).join(";") :
        "";

      e.stopPropagation();
    },
    /**
     * 新增货位
     */
    resetLocationForm () {
      this.locationForm = {
        no: "",
        name: "",
        remark: "",
        $index: this.form.details.length + 1,
      };
    },
    addLocation () {
      this.resetLocationForm();
      this.openLocationDialog = true;
    },
    locationCancel () {
      this.$my_confirm("确认要中断当前操作吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.openLocationDialog = false;
        })
        .catch(() => { });
    },
    locationSubmit () {
      this.$refs["locationForm"].validate((valid) => {
        if (!valid) {
          return false;
        }

        let item = this.form.details.find((i) => i.$index == this.locationForm.$index);
        if (!item) {
          this.form.details.push(this.locationForm);
        } else {
          Object.assign(item, this.locationForm);
        }

        this.openLocationDialog = false;
      });
    },
    editLocation (item) {
      this.resetLocationForm();
      this.openLocationDialog = true;
      this.locationForm = JSON.parse(JSON.stringify(item));
    },
    removeLocation (location) {
      this.form.details = this.form.details.filter((i) => i.$index != location.$index);
      this.form.details.forEach((e, index) => {
        e.$index = index + 1;
      });
    },
    /**
     * 库存阈值配置
     */
    resetWarnForm () {
      this.warnForm = {
        warnIds: "",
        name: "",
        remark: "",
        productName: "",
        warnIdArr: [],
        warnInfos: [],
        $index: this.form.warnDetails.length + 1,
      };
    },
    addSetting () {
      this.resetWarnForm();
      this.openSettingDialog = true;
      this.getProductList();
    },
    settingCancel () {
      this.$my_confirm("确认要中断当前操作吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.openSettingDialog = false;
        })
        .catch(() => { });
    },
    settingSubmit () {
      this.$refs["warnForm"].validate((valid) => {
        if (!valid) {
          return false;
        }
        let item = this.form.warnDetails.find((i) => i.$index == this.warnForm.$index);
        if (!item) {
          this.form.warnDetails.push(this.warnForm);
        } else {
          Object.assign(item, this.warnForm);
        }

        this.openSettingDialog = false;
      });
    },
    editSetting (item) {
      this.resetWarnForm();
      this.openSettingDialog = true;
      this.warnForm = JSON.parse(JSON.stringify(item));
      if (item.warnInfos) {
        this.$set(
          this.warnForm,
          "warnIdArr",
          item.warnInfos.map((item) => item.id)
        );
        item.warnInfos.map((item) => {
          var user = this.STATIC_Users.filter((e) => e.id == item.id);
          if (!user || user.length == 0) {
            this.STATIC_Users.push(item);
          }
        });
      }
    },
    removeSetting (item) {
      this.form.warnDetails = this.form.warnDetails.filter(
        (i) => i.$index != item.$index
      );
      this.form.warnDetails.forEach((e, index) => {
        e.$index = index + 1;
      });
    },
    warnDetailChange (val) {
      // this.warnForm.warnId = val;
      this.warnForm.warnIds = val.join(";");
    },
    productChange (row) {
      this.warnForm.productName = row.productName;
      this.warnForm.supplierProductId = row.id;
      this.warnForm.specId = row.specId;
      this.warnForm.specName = row.specName;
      // console.log(this.warnForm.supplierProductId, ' this.warnForm.supplierProductId');
    },
    getProductList (keyWord) {
      this.getSupplierProducts({
        keyWord: keyWord,
        pageIndex: 1,
        pageSize: 100,
        status: 2,
      });
    },
    ///


      //弹窗标签双击修改事件
      tagDbClickEvt(num){
                this.tagIndex = num
                this.tagInput = this.dynamicTags[num]
                this.$nextTick(_ => {
                     this.$refs.tagInput.$refs.input.focus()
                });
            },
    // 标签修改
    tegInputEvt (num) {
      if (!this.tagInput) {
        return
      }
      this.dynamicTags[num] = this.tagInput
      this.tagIndex = null

    },
    handleInputConfirm () {
      let inputValue = this.inputValue1;
      let arr = this.dynamicTags.filter(res => res == inputValue)
      if (arr.length !== 0) {
        this.$message({
          message: '不能输入相同的地址',
          type: 'warning'
        });
        return
      }
      if (inputValue == ' ') {
        this.$message({
          message: '请输入地址',
          type: 'warning'
        });

        return
      }
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = true;
      this.inputValue1 = '';
    },
    handleClose (tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    showInput () {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm () {
      let inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    billingDecoupledChange(val){
      if(val){
        this.form.isAutoCreateDeptInStock = 1
      }else{

      }
    },
  
  },
};
</script>

<style lang="scss" scoped>
.addressBox {

  width: 100%;
  min-width: 320px;
  min-height: 36px;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
  background-color: #FFFFFF;
  background-image: none;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
}

.addAddress {
  color: #286ab4;
}


.el-tag--medium{
  margin-left: 5px;
  margin-top: 5px;
}
</style>
